/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
	{
		path: '/',
		// Relative to /src/views
		view: 'Dashboard',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/login',
		view: 'Auth/Login',
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/machines/vendors',
		view: 'machines/vendors',
		name: 'Machine Vendors Index',
		meta: {
			requiresAuth: true,
			title: 'Список производителей',
		},
	},
	{
		path: '/machines/vendors/:id',
		view: 'machines/index',
		name: 'Machines Index',
		meta: {
			requiresAuth: true,
			title: 'Список машин',
		},
	},
	{
		path: '/machines/:id(\\d+)',
		props: true,
		view: 'machines/show',
		name: 'Machines Show',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/products',
		view: 'products/index',
		name: 'Products Index',
		meta: {
			requiresAuth: true,
			title: 'Список товаров',
		},
	},
	{
		path: '/products/:id',
		props: true,
		view: 'products/show',
		name: 'Products Show',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/clients',
		view: 'clients/index',
		name: 'Clients Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/clients/:id',
		view: 'clients/show',
		name: 'Clients Show',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/tags',
		view: 'tags/index',
		name: 'Tags Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/articles',
		view: 'articles/index',
		name: 'Articles Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/articles/create',
		view: 'articles/save',
		name: 'Articles Create',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/articles/:slug',
		view: 'articles/save',
		name: 'Articles Edit',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/stocks',
		view: 'stocks/index',
		name: 'Stocks Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/stocks/create',
		view: 'stocks/save',
		name: 'Stocks Create',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/stocks/:slug',
		view: 'stocks/save',
		name: 'Stocks Edit',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/groups',
		view: 'groups/index',
		name: 'Groups Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/shop-products',
		view: 'shop-products/index',
		name: 'Shop Products Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/users',
		view: 'users/index',
		name: 'UsersIndex',
		meta: {
			requiresAuth: true,
		},
	},
	// DEFAULT ROUTES
	{
		path: '/notifications',
		view: 'Notifications',
		meta: {
			requiresAuth: true,
		},
	},

	// REPAIR ORDERS
	{
		path: '/cities',
		view: 'cities/index',
		name: 'Cities Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/orders/repair',
		view: 'orders/repair/index',
		name: 'RepairOrders Index',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/orders/repair/create',
		view: 'orders/repair/create',
		name: 'RepairOrders Create',
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/orders/repair/:order',
		view: 'orders/repair/show',
		name: 'RepairOrders Show',
		meta: {
			requiresAuth: true,
		},
	},
]
